export default __webpack_public_path__ + "static/media/solar-maintenance.a9bc4733.svg";